import { render } from "./loginNext.vue?vue&type=template&id=28874493"
import script from "./loginNext.vue?vue&type=script&lang=js"
export * from "./loginNext.vue?vue&type=script&lang=js"

import "./loginNext.vue?vue&type=style&index=0&id=28874493&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__